// src/components/locutor/LocutorStatusPanel.jsx
import React from 'react';
import { formatTimeRemaining } from './locutorConstants';

export function LocutorStatusPanel({
  locutor, falando, configReady, status, ultimaFala,
  faixasDesdeUltimaLocucao, faixasPorLocucao,
  isScheduled, scheduledIn, scheduledTime,
  textoImediato, setTextoImediato, erroTextoImediato,
  ativarLocutorAutomatico, falarAgoraImediato,
}) {

  const card = {
    padding: '12px 14px', borderRadius: 0, marginBottom: 10,
    background: 'rgba(var(--neutral-400-rgb), 0.98)',
    border: '1px solid rgba(var(--brand-rgb), 0.3)',
    color: 'white',
  };

  return (
    <>
      {/* Texto imediato */}
      <div style={{ marginBottom: 12 }}>
        <label style={{ display: 'block', fontSize: 12, color: 'var(--text-secondary)', marginBottom: 5 }}>
          Texto da locução imediata
        </label>
        <textarea
          value={textoImediato}
          onChange={e => setTextoImediato(e.target.value)}
          rows={2}
          placeholder="Digite o que o locutor deve falar agora..."
          style={{
            width: '100%', resize: 'vertical', fontSize: 13,
            padding: '8px 12px', borderRadius: 8,
            background: 'rgba(var(--neutral-400-rgb), 0.98)',
            border: '1px solid rgba(var(--brand-rgb), 0.3)',
            color: 'white',
          }}
        />
        {erroTextoImediato && (
          <div style={{ color: 'var(--error)', fontSize: 12, marginTop: 4 }}>{erroTextoImediato}</div>
        )}
      </div>

      {/* Botões principais */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
        <button
          onClick={ativarLocutorAutomatico}
          disabled={falando || !configReady}
          style={{
            flex: 1, padding: '12px 16px', borderRadius: 8, border: 'none',
            fontWeight: 600, fontSize: 15, color: 'white',
            cursor: falando || !configReady ? 'not-allowed' : 'pointer',
            opacity: falando || !configReady ? 0.5 : 1,
            background: locutor.ativo
              ? 'rgba(var(--error-rgb), 0.85)'
              : 'var(--gradient-success)',
            boxShadow: locutor.ativo
              ? '0 2px 12px rgba(var(--error-rgb), 0.35)'
              : '0 2px 12px rgba(var(--success-rgb), 0.35)',
          }}
        >
          {locutor.ativo ? '⏸️ Parar' : '▶️ Auto'}
        </button>

        <button
          onClick={() => falarAgoraImediato(textoImediato || undefined)}
          disabled={falando || !configReady}
          style={{
            flex: 1, padding: '12px 16px', borderRadius: 8, border: 'none',
            fontWeight: 600, fontSize: 15, color: 'white',
            cursor: falando || !configReady ? 'not-allowed' : 'pointer',
            opacity: falando || !configReady ? 0.5 : 1,
            background: 'var(--action)',
            boxShadow: 'none',
          }}
        >
          🎙 Falar Agora
        </button>
      </div>

      {/* Status */}
      {status && (
        <div style={{ ...card, textAlign: 'center', fontSize: 13, color: 'var(--brand-400)' }}>
          {status}
        </div>
      )}

      {/* Locutor agendado na música */}
      {isScheduled && scheduledIn !== null && (
        <div style={{
          ...card,
          background: 'rgba(var(--success-rgb), 0.1)',
          border: '1px solid rgba(var(--success-rgb), 0.4)',
        }}>
          <div style={{ fontSize: 12, color: 'var(--success)', fontWeight: 500, marginBottom: 8 }}>
            🎙 Locutor agendado na música
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
            <span style={{ fontSize: 12, color: 'var(--text-secondary)' }}>Fala em</span>
            <span style={{
              fontSize: 22, fontWeight: 700, color: 'var(--success)',
              fontVariantNumeric: 'tabular-nums',
              animation: scheduledIn < 10 ? 'pulse 1s infinite' : 'none',
            }}>
              {formatTimeRemaining(scheduledIn)}
            </span>
          </div>
          {scheduledTime && (
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 6 }}>
              <span style={{ fontSize: 12, color: 'var(--text-secondary)' }}>Horário</span>
              <span style={{ fontSize: 13, color: 'var(--text-primary)', fontVariantNumeric: 'tabular-nums' }}>
                {scheduledTime.toLocaleTimeString('pt-BR')}
              </span>
            </div>
          )}
        </div>
      )}

      {/* Frequência confirmada pelo backend */}
      {locutor.ativo && Number.isInteger(faixasPorLocucao) && !isScheduled && (
        <div style={{ ...card, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: 12, color: 'var(--text-secondary)' }}>Frequência</span>
          <span style={{ fontSize: 13, color: 'var(--brand-400)', fontVariantNumeric: 'tabular-nums' }}>
            {faixasDesdeUltimaLocucao}/{faixasPorLocucao} faixas
          </span>
        </div>
      )}

      {/* Última fala */}
      {ultimaFala && (
        <div style={{
          ...card,
          borderLeft: '3px solid var(--warning)',
          borderRadius: 0,
        }}>
          <div style={{ fontSize: 11, color: 'var(--text-secondary)', marginBottom: 5 }}>Última fala</div>
          <p style={{ fontSize: 13, color: 'var(--text-primary)', fontStyle: 'italic', margin: 0, lineHeight: 1.6 }}>
            "{ultimaFala}"
          </p>
        </div>
      )}
    </>
  );
}
